import axios from 'axios';
import store from "@/store";
import router from "@/router";

function resolveApiBaseUrl() {
  const configured = (process.env.VUE_APP_API_URL || '').trim();
  const hasTemplateVars = configured.includes('${');
  const host = window.location.hostname;
  const isLocalHost = host === '127.0.0.1' || host === 'localhost';

  // Local host-mode setup: frontend and backend are different ports, so use
  // same-origin /api and let the local frontend server proxy to backend.
  if (isLocalHost) {
    return '/api';
  }

  const configuredLooksBroken = configured.includes('..');
  if (configured && !hasTemplateVars && !configuredLooksBroken) {
    return configured;
  }

  // Nginx proxy convention in this repo: frontend on HOST.DOMAIN,
  // backend on api.HOST.DOMAIN.
  if (host.startsWith('api.')) {
    return `${window.location.protocol}//${window.location.host}`;
  }

  return `${window.location.protocol}//api.${window.location.host}`;
}

axios.defaults.withCredentials = true;
axios.defaults.baseURL = resolveApiBaseUrl();

axios.interceptors.response.use(undefined, function (error) {
  if (!error) {
    return Promise.reject({code: 'UNKNOWN_ERROR'});
  }
  if (error.response) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      store.dispatch('logOut');
      return router.push({name: 'login'});
    }
  }
  return Promise.reject(error);
});

export default axios;
